import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles/print.css';
import './i18n';
import App from './App.tsx';
import { env } from '@/config';

function renderApp() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

async function bootstrap() {
  if (env.mockApiEnabled) {
    const { worker } = await import('@/mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  renderApp();
}

void bootstrap();
